import type { Editor } from '@tiptap/react';

import { useTiptapEditor } from '@/hooks/use-tiptap-editor';

import { TableGridSelector } from './table-grid-selector';
import type { TableInsertType } from './use-table-trigger';
import { useTableTriggerButton } from './use-table-trigger';

export interface TableInsertGridPanelProps {
    editor?: Editor | null;
    mode?: TableInsertType;
    maxRows?: number;
    maxCols?: number;
    focusInputs?: boolean;
    onInserted?: (rows: number, cols: number) => void;
}

export function TableInsertGridPanel({
    editor: providedEditor,
    mode = 'table',
    maxRows = 8,
    maxCols = 8,
    focusInputs = false,
    onInserted,
}: TableInsertGridPanelProps) {
    const { editor } = useTiptapEditor(providedEditor);
    const {
        dimensions,
        hoveredCell,
        handleDimensionsChange,
        handleInsert,
        handleCellHover,
        handleCellClick,
        columnsInputRef,
        rowsInputRef,
        canInsert,
    } = useTableTriggerButton({
        editor,
        mode,
        maxRows,
        maxCols,
        focusInputs,
        onInserted,
    });

    return (
        <TableGridSelector
            maxRows={maxRows}
            maxCols={maxCols}
            dimensions={dimensions}
            onDimensionsChange={handleDimensionsChange}
            onInsert={handleInsert}
            hoveredCell={hoveredCell}
            onCellHover={handleCellHover}
            onCellClick={handleCellClick}
            columnsInputRef={columnsInputRef}
            rowsInputRef={rowsInputRef}
            disabled={!canInsert}
        />
    );
}
